module.exports = __webpack_public_path__ + "65985a82ca5fff7fc50b0055760cb6aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/pattern/0.svg
// module id = 695
// module chunks = 0